import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'lib-line-loader',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './line-loader.component.html',
  styleUrls: ['./line-loader.component.scss'],
})
export class LineLoaderComponent {}
